module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cf-pro-message-settings"
    }
  }, [_c('div', {
    attrs: {
      "id": "cf-pro-message-setting-inner"
    }
  }, [_c('div', {
    staticClass: "caldera-editor-header"
  }, [_c('ul', {
    staticClass: "caldera-editor-header-nav"
  }, [_vm._m(0), _vm._v(" "), (_vm.connected) ? _c('li', {
    staticClass: "status good"
  }, [_vm._v("\n\t\t\t\t\tConnected\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.connected) ? _c('li', {
    staticClass: "status bad"
  }, [_vm._v("\n\t\t\t\t\tNot Connected\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "cf-pro-save"
  }, [_c('input', {
    staticClass: "button button-primary",
    attrs: {
      "type": "submit",
      "value": "Save"
    },
    on: {
      "click": _vm.save
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "cf-pro-alert-wrap"
    }
  }, [_c('status', {
    attrs: {
      "message": _vm.mainAlert.message,
      "success": _vm.mainAlert.success,
      "show": _vm.mainAlert.show
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "cf-pro-settings"
  }, [_c('div', [_c('tabs', {
    attrs: {
      "options": {
        useUrlFragment: false
      }
    }
  }, [_c('tab', {
    attrs: {
      "name": "Account"
    }
  }, [_c('account-edit')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Form Settings"
    }
  }, [(_vm.connected) ? _c('div', [_c('forms-settings')], 1) : _c('div', [_vm._v("\n\t\t\t\t\t\t\tYou must connected to Caldera Forms Pro First\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Settings"
    }
  }, [_c('delivery'), _vm._v(" "), _c('logs')], 1)], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "caldera-editor-logo"
  }, [_c('span', {
    staticClass: "caldera-forms-name"
  }, [_vm._v("\n\t\t\t\t\t\tCaldera Forms Pro\n\t\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16fab070"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Settings.vue
// module id = 227
// module chunks = 1